"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isGrind = exports.grindTokenCount = exports.soldiers = undefined;

var _reselect = require("reselect");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _selectUtils = require("../../../../select-utils");

var _stats = require("./stats");

var _raw = require("../raw");

var RawChar = _interopRequireWildcard(_raw);

var _reify = require("./reify");

var Reify = _interopRequireWildcard(_reify);

var _visible = require("./visible");

var Vis = _interopRequireWildcard(_visible);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var soldiers = exports.soldiers = (0, _reselect.createSelector)(Reify.counts, Vis.visibleCombatNames, _lodash2.default.pick);
var grindTokenCount = exports.grindTokenCount = (0, _selectUtils.withFixedProps)({ unitName: "_lootGrindToken" }, Reify.count);
var isNotZero = (0, _reselect.createSelector)(Reify.count, function (c) {
  return !c.isZero();
});
var isGrind = exports.isGrind = (0, _selectUtils.withFixedProps)({ unitName: "_lootGrindToken" }, isNotZero);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvdW5pdHMvY29tYmF0LmpzIl0sIm5hbWVzIjpbIlJhd0NoYXIiLCJSZWlmeSIsIlZpcyIsInNvbGRpZXJzIiwiY291bnRzIiwidmlzaWJsZUNvbWJhdE5hbWVzIiwicGljayIsImdyaW5kVG9rZW5Db3VudCIsInVuaXROYW1lIiwiY291bnQiLCJpc05vdFplcm8iLCJjIiwiaXNaZXJvIiwiaXNHcmluZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOztBQUNBOzs7O0FBQ0E7O0FBQ0E7O0FBQ0E7O0lBQVlBLE87O0FBQ1o7O0lBQVlDLEs7O0FBQ1o7O0lBQVlDLEc7Ozs7OztBQUVMLElBQU1DLDhCQUdjLDhCQUN6QkYsTUFBTUcsTUFEbUIsRUFFekJGLElBQUlHLGtCQUZxQixFQUd6QixpQkFBRUMsSUFIdUIsQ0FIcEI7QUFTQSxJQUFNQyw0Q0FBa0IsaUNBQzdCLEVBQUNDLFVBQVUsaUJBQVgsRUFENkIsRUFFN0JQLE1BQU1RLEtBRnVCLENBQXhCO0FBSVAsSUFBTUMsWUFBWSw4QkFBZVQsTUFBTVEsS0FBckIsRUFBNEI7QUFBQSxTQUFLLENBQUNFLEVBQUVDLE1BQUYsRUFBTjtBQUFBLENBQTVCLENBQWxCO0FBQ08sSUFBTUMsNEJBQVUsaUNBQWUsRUFBQ0wsVUFBVSxpQkFBWCxFQUFmLEVBQThDRSxTQUE5QyxDQUFoQiIsImZpbGUiOiJjb21iYXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0IHtjcmVhdGVTZWxlY3Rvcn0gZnJvbSBcInJlc2VsZWN0XCJcbmltcG9ydCBfIGZyb20gXCJsb2Rhc2hcIlxuaW1wb3J0IHt3aXRoRml4ZWRQcm9wc30gZnJvbSBcIi4uLy4uLy4uLy4uL3NlbGVjdC11dGlsc1wiXG5pbXBvcnQge0RlY2ltYWx9IGZyb20gXCIuL3N0YXRzXCJcbmltcG9ydCAqIGFzIFJhd0NoYXIgZnJvbSBcIi4uL3Jhd1wiXG5pbXBvcnQgKiBhcyBSZWlmeSBmcm9tIFwiLi9yZWlmeVwiXG5pbXBvcnQgKiBhcyBWaXMgZnJvbSBcIi4vdmlzaWJsZVwiXG5cbmV4cG9ydCBjb25zdCBzb2xkaWVyczogKFxuICAqLFxuICB7Y2hhcmFjdGVyPzogUmF3Q2hhci5TdGF0ZSwgY2hhcklkPzogc3RyaW5nLCBmaXhlZE5vdzogbnVtYmVyfSxcbikgPT4ge1tzdHJpbmddOiBEZWNpbWFsfSA9IGNyZWF0ZVNlbGVjdG9yKFxuICBSZWlmeS5jb3VudHMsXG4gIFZpcy52aXNpYmxlQ29tYmF0TmFtZXMsXG4gIF8ucGljayxcbilcblxuZXhwb3J0IGNvbnN0IGdyaW5kVG9rZW5Db3VudCA9IHdpdGhGaXhlZFByb3BzKFxuICB7dW5pdE5hbWU6IFwiX2xvb3RHcmluZFRva2VuXCJ9LFxuICBSZWlmeS5jb3VudCxcbilcbmNvbnN0IGlzTm90WmVybyA9IGNyZWF0ZVNlbGVjdG9yKFJlaWZ5LmNvdW50LCBjID0+ICFjLmlzWmVybygpKVxuZXhwb3J0IGNvbnN0IGlzR3JpbmQgPSB3aXRoRml4ZWRQcm9wcyh7dW5pdE5hbWU6IFwiX2xvb3RHcmluZFRva2VuXCJ9LCBpc05vdFplcm8pXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/units/combat.js
// module id = 369
// module chunks = 0